<template>
  <div>
    <AppCard
      :title="$t('title.smtp')"
      class="dash-provider"
      header-color="bg-grey-11"
      bordered
    >
      <div
        v-for="(item, index) in smtpList"
        :key="item.id"
        class="border-bottom row q-pa-lg"
      >
        <div class="row items-center col-7">
          <div class="q-pa-xs">
            <q-icon
              name="fl:message_open"
              color="grey-7"
              size="20px"
            />
          </div>
          <div class="q-pl-sm text-15-700">{{ item.title }}</div>
        </div>
        <div class="row items-center col-5 justify-end">
          <div class="q-pr-md text-grey">{{ item.server.address }}</div>
          <q-icon
            name="fa-solid fa-ellipsis-vertical"
            class="cursor-pointer"
            size="13px"
          >
            <ContextMenu>
              <ContextMenuButton
                :label="$t('button.edit')"
                icon-left="fl:set"
                @click="onEdit(smtpList[index])"
              />
              <ContextMenuButton
                :label="$t('button.testSmtp')"
                icon-left="fl:send"
                @click="onTest(smtpList[index])"
              />
              <ContextMenuButton
                :label="$t('button.delete')"
                icon-left="fl:trash"
                @click="onOpenRemoveDialog(smtpList[index])"
              />
            </ContextMenu>
          </q-icon>
        </div>
      </div>
      <div class="q-pa-lg">
        <AppButtonLink
          :label="$t('button.addNewSmtp')"
          icon-right="fl:add_round"
          icon-right-color="primary"
          padding="5px 22px"
          full-width
          @click="onAddNewSmtp"
        />
      </div>
    </AppCard>

    <AttentionDialog
      v-if="showRemoveDialog"
      :title="$t('title.attention')"
      is-open
      @close="onCloseRemoveDialog"
    >
      <div class="row justify-center">
        <div class="col-8">
          <div class="text-19-400 text-center q-py-lg">
            {{ $t('text.deleteConfirm', [model.title]) }}
          </div>
        </div>
      </div>
      <template #footer>
        <AppButton
          v-close-popup
          :label="$t('button.cancel')"
          class="col"
          color="white"
          text-color="black"
          outline
        />
        <AppButton
          :label="$t('button.remove')"
          :loading="loading.remove"
          label-class="q-px-sm"
          class="col"
          icon-right="fl:trash"
          icon-right-size="24px"
          @click="onDeleteSmtp"
        />
      </template>
    </AttentionDialog>

    <SmtpFormDialog
      v-if="showSmtpDialog"
      v-model="model"
      :is-create="isCreate"
      @close="onCloseSmtpDialog"
      @remove="onOpenRemoveDialog(model)"
    />

    <SmtpTestFormDialog
      v-if="showSmtpTestDialog"
      :smtp="model"
      @close="showSmtpTestDialog = false"
    />
  </div>
</template>

<script>
import AppCard from 'common/components/AppCard';
import AppButton from 'common/components/buttons/AppButton';
import AppButtonLink from 'common/components/buttons/AppButtonLink';
import ContextMenu from 'common/components/contextMenu/ContextMenu';
import ContextMenuButton from 'common/components/contextMenu/ContextMenuButton';
import AttentionDialog from 'common/components/dialogs/AttentionDialog';
import SmtpFormDialog from 'common/components/dialogs/SmtpFormDialog';
import SmtpTestFormDialog from 'common/components/dialogs/SmtpTestFormDialog';
import handleError from 'common/helpers/handleError';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SmtpPage',
  components: {
    SmtpTestFormDialog,
    AppButton,
    AppButtonLink,
    AppCard,
    AttentionDialog,
    ContextMenu,
    ContextMenuButton,
    SmtpFormDialog,
  },
  data() {
    return {
      showRemoveDialog: false,
      showSmtpDialog: false,
      showSmtpTestDialog: false,
      isCreate: false,
      model: undefined,
      loading: {
        remove: false,
      },
    };
  },
  computed: {
    ...mapState('smtp', ['smtpList']),
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions('smtp', ['fetchSmtpList', 'removeSmtp']),
    async fetch() {
      try {
        this.$q.loading.show();
        await this.fetchSmtpList();
      } catch (error) {
        handleError(error);
      } finally {
        this.$q.loading.hide();
      }
    },
    setModel(model = undefined) {
      this.model = model ? { ...model } : model;
    },
    onAddNewSmtp() {
      this.setModel();
      this.isCreate = true;
      this.showSmtpDialog = true;
    },
    onEdit(smtp) {
      this.setModel(smtp);
      this.isCreate = false;
      this.showSmtpDialog = true;
    },
    onTest(smtp) {
      this.setModel(smtp);
      this.showSmtpTestDialog = true;
    },
    onOpenRemoveDialog(smtp) {
      this.setModel(smtp);
      this.showRemoveDialog = true;
    },
    async onDeleteSmtp() {
      try {
        this.loading.remove = true;
        await this.removeSmtp(this.model.guid);
        this.setModel();
        this.showRemoveDialog = false;
        this.showSmtpDialog = false;
      } catch (error) {
        handleError(error);
      } finally {
        this.loading.remove = false;
      }
    },
    onCloseRemoveDialog() {
      this.setModel();
      this.showRemoveDialog = false;
    },
    onCloseSmtpDialog() {
      this.setModel();
      this.showSmtpDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dash-provider {
  width: $form-width;
}
</style>
